export default __webpack_public_path__ + "static/media/airtable.86700dd9.png";